const styles = {
    container: {
      padding: '1rem',
      maxWidth: '600px',
    },
    list: {
      listStyle: 'none',
      padding: 0,
    },
    item: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0.75rem 1rem',
      border: '1px solid #ddd',
      borderRadius: '6px',
      marginBottom: '0.5rem',
      backgroundColor: '#f9f9f9',
    },
    title: {
      fontWeight: 500,
    },
    button: {
      backgroundColor: '#ff4d4f',
      color: 'white',
      border: 'none',
      padding: '0.4rem 0.8rem',
      borderRadius: '4px',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease',
    },
  };
  
  const SavedTemplatesList = ({ templates, onUnsave, isOwner }) => {
    return (
      <div style={styles.container}>
        {templates.length === 0 ? (
          <p>No templates saved yet.</p>
        ) : (
          <ul style={styles.list}>
            {templates.map((template) => (
              <li key={template.id} style={styles.item}>
                <span style={styles.title}>{template.title}</span>
                {isOwner && (
                  <button
                    style={styles.button}
                    onClick={() => onUnsave(template.id)}
                  >
                    Unsave
                  </button>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  };

export default SavedTemplatesList;
